import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 3v18h18","key":"svg-0"}],["path",{"d":"M20 18v3","key":"svg-1"}],["path",{"d":"M16 16v5","key":"svg-2"}],["path",{"d":"M12 13v8","key":"svg-3"}],["path",{"d":"M8 16v5","key":"svg-4"}],["path",{"d":"M3 11c6 0 5 -5 9 -5s3 5 9 5","key":"svg-5"}]]

const IconChartHistogram = createReactComponent('outline', 'chart-histogram', 'ChartHistogram', __iconNode);

export default IconChartHistogram;